import { IoLeafOutline, IoMoonOutline, IoSunnyOutline } from "react-icons/io5";
import { useTheme } from "../theme/ThemeContext";

const OPTIONS = [
  { id: "sportmingle", label: "Sport", Icon: IoLeafOutline },
  { id: "dark", label: "Dark", Icon: IoMoonOutline },
  { id: "light", label: "Light", Icon: IoSunnyOutline },
];

const ThemeSwitcher = () => {
  const { theme, setTheme } = useTheme();

  return (
    <div className="sm-theme-switcher" role="group" aria-label="Color theme">
      {OPTIONS.map(({ id, label, Icon }) => (
        <button
          key={id}
          type="button"
          className={theme === id ? "sm-theme-btn active" : "sm-theme-btn"}
          onClick={() => setTheme(id)}
          aria-pressed={theme === id}
          title={`${label} theme`}
        >
          <Icon />
          <span>{label}</span>
        </button>
      ))}
    </div>
  );
};

export default ThemeSwitcher;
